var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-book-version" }, [
    _c("div", { staticClass: "textbookVersions" }, [
      _c(
        "div",
        { staticClass: "textbookVersions-table" },
        [
          _c(
            "el-table",
            {
              attrs: {
                "header-cell-style": {
                  background: "#eef1f6",
                  color: "#606266",
                },
                data: _vm.tableData,
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "code", label: "课程代码" },
              }),
              _c("el-table-column", {
                attrs: { prop: "course_title", label: "课程名称" },
              }),
              _c("el-table-column", {
                attrs: { prop: "title", label: "教材名称" },
              }),
              _c("el-table-column", {
                attrs: { prop: "edition", label: "教材版本" },
              }),
              _c("el-table-column", {
                attrs: { prop: "author", label: "作者" },
              }),
              _c("el-table-column", {
                attrs: { prop: "press", label: "出版社" },
              }),
              _c("el-table-column", {
                attrs: { prop: "start_date", label: "启用时间" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }